"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.relativeLuminance = void 0;
var tslib_1 = require("tslib");
/**
 * link: https://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
 */
var relativeLuminance = function (_a) {
    var _b = tslib_1.__read(_a, 3), r = _b[0], g = _b[1], b = _b[2];
    return 0.2126 * f(r / 255) + 0.7152 * f(g / 255) + 0.0722 * f(b / 255);
};
exports.relativeLuminance = relativeLuminance;
var f = function (v) {
    return v <= 0.03928 ? v / 12.92 : Math.pow(((v + 0.055) / 1.055), 2.4);
};
